import {Types} from "../../../type/Types";

export type CampaignValueObject = {
    id: bigint
    landingUrl: string
    title: string
    description: string
    bannerImageUrl: string
    iconImageUrl: string
    category: string
    point : number
    createdAt: Date
    modifiedAt: Date | null
    deletedAt: Date | null
}

export namespace CampaignValueObject {
    export function construct(o: any): CampaignValueObject {
        return {
            id: BigInt(o.id),
            landingUrl: String(o.landingUrl),
            title: String(o.title),
            description: String(o.description),
            bannerImageUrl: String(o.bannerImageUrl),
            iconImageUrl: String(o.iconImageUrl),
            category: String(o.category),
            point: Number(o.point),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
            deletedAt: Types.asNull(o.deletedAt, o => new Date(o)),
        }
    }

    export const description: Record<keyof CampaignValueObject, string> = {
        id: 'ID',
        landingUrl: '연결URL',
        title: '제목',
        description: '설명',
        bannerImageUrl: '배너이미지',
        iconImageUrl: '아이콘이미지',
        category: '카테고리',
        point: '포인트',
        createdAt: '생성 시각',
        modifiedAt: '수정 시각',
        deletedAt: '삭제 시각',
    }
}